import './bootstrap';
import './pages/upload-check.js';

import { createApp, ref, onMounted } from 'vue';
import _ from 'lodash';
import FlushMessage from './components/FlushMessage.vue';
import UploadFormComponent from './components/UploadFormComponent.vue';
import DateTimeComponent from './components/DateTimeComponent.vue';
import TagAutoInputComponent from './components/TagAutoInputComponent.vue';
import MultiUploadFormComponent from './components/MultiUploadFormComponent.vue';
import Player from './components/Player.vue';
import ExpireDateComponent from './components/ExpireDateComponent.vue';
import AreaTagComponent from './components/AreaTagComponent.vue';
import Videojs from './components/Videojs.vue';
import ClipCreatorComponent from './components/ClipCreatorComponent.vue';

const app = createApp({
  setup() {
    const isUploading = ref(false);
    const isSubmit = ref(false);
    const selectAll = ref(false);
    const selectedItems = ref([]);
    const items = ref([]);

    onMounted(() => {
      const appElement = document.getElementById('app');
      if (appElement) {
        items.value = JSON.parse(appElement.getAttribute('data-items') || '[]');
      }
    });

    const uploadingStatus = (status) => {
      console.log('uploading', status);
      isUploading.value = status;
    };

    const createClip = () => {
      console.log('ClipCreator');
    };

    const toggleSelectAll = () => {
      const checkboxes = document.querySelectorAll('.deleteCheckbox');
      checkboxes.forEach((checkbox) => {
        checkbox.checked = selectAll.value;
      });
      selectedItems.value = selectAll.value
        ? Array.from(checkboxes).map((checkbox) => checkbox.value)
        : [];
    };

    const toggleCheckbox = () => {
      const checkboxes = document.querySelectorAll('.deleteCheckbox');
      selectedItems.value = Array.from(checkboxes)
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value);

      selectAll.value = selectedItems.value.length === checkboxes.length;
    };

    return {
      isUploading,
      isSubmit,
      selectAll,
      selectedItems,
      items,
      uploadingStatus,
      createClip,
      toggleSelectAll,
      toggleCheckbox,
    };
  },
});

// グローバルプロパティとして `__` を登録
app.config.globalProperties.__ = (str) => _.get(window.i18n, str);

// コンポーネント登録
app.component('flush', FlushMessage);
app.component('upload-form', UploadFormComponent);
app.component('datetime', DateTimeComponent);
app.component('tagselect', TagAutoInputComponent);
app.component('multi-upload-form', MultiUploadFormComponent);
app.component('player', Player);
app.component('expire-date', ExpireDateComponent);
app.component('area-tag', AreaTagComponent);
app.component('videojs', Videojs);
app.component('clip-creator', ClipCreatorComponent);

// Vue アプリをマウント
app.mount('#app');
